<template>
  <div class="container py-5">
    <br>
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
        <i class="fal fa-3x fa-check-circle green animated pulse"></i>
        <h1 class="h3 mt-3">Success!</h1>
        <p class="lead grey">Your information is now received.</p>
        <hr>
        <p>We'll reach out shortly!</p>
        <p><small><router-link to="/" class="blue">← Back to frontpage</router-link></small></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    mounted() {
      this.$store.commit('meta/title', 'Success!')
    },
}
</script>
